import React, { useEffect } from 'react';
import { MapPin, Phone, Mail, Clock } from '../../icons';

function Contact() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    const items = [
        { Icon: MapPin, label: 'Adresse',   value: '14 rue Curial, Paris — Île-de-France', href: null },
        { Icon: Phone,  label: 'Téléphone', value: '+33 7 53 06 01 90',                    href: 'tel:+33753060190' },
        { Icon: Mail,   label: 'E-mail',    value: 'contact@eudeliv.com',                  href: 'mailto:contact@eudeliv.com' },
        { Icon: Clock,  label: 'Horaires',  value: 'Lun – Ven, 9h – 18h',                 href: null },
    ];

    return (
        <div>
            <div className="page-hero">
                <div className="container">
                    <p className="page-hero__eyebrow">Support</p>
                    <h1 className="page-hero__title">On est là pour vous aider</h1>
                    <p className="page-hero__subtitle">
                        Une question, une suggestion ou un problème ? Notre équipe vous répond sous 24h.
                    </p>
                </div>
            </div>

            <div className="container content-page">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-7 col-lg-5">
                        <div className="contact-card">
                            <h2 style={{ fontSize: '1.3rem', fontWeight: 800, color: 'var(--dark)', marginBottom: 28 }}>
                                Nos coordonnées
                            </h2>

                            {items.map(({ Icon, label, value, href }) => (
                                <div key={label} className="contact-item">
                                    <div className="contact-item__icon">
                                        <Icon size={20} strokeWidth={1.8} />
                                    </div>
                                    <div>
                                        <p className="contact-item__label">{label}</p>
                                        <p className="contact-item__value">
                                            {href
                                                ? <a href={href} style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>{value}</a>
                                                : value
                                            }
                                        </p>
                                    </div>
                                </div>
                            ))}

                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 8 }}>
                                <a href="tel:+33753060190" className="btn btn-primary"
                                    style={{ borderRadius: 50, padding: '12px 24px', fontWeight: 700, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                    <Phone size={16} strokeWidth={2.5} /> Appeler
                                </a>
                                <a href="mailto:contact@eudeliv.com" className="btn btn-primary"
                                    style={{ borderRadius: 50, padding: '12px 24px', fontWeight: 700, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                    <Mail size={16} strokeWidth={2.5} /> Envoyer un e-mail
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
